<ng-container *ngIf="vo$ | async; let vo">
	<div
		class="app-subscription-create">
		<button
			*ngIf="vo.hasCreatePermission"
			matTooltip="new"
			id="{{ cmpId }}-new-btn"
			i18n-matTooltip="@@general.action.new"
			class="subscription-list-new"
			mat-icon-button
			color="primary"
			(click)="createNew()">
			<mat-icon [svgIcon]="DcIcons.AddElement"></mat-icon>
		</button>
	</div>

	<app-subscription-list
		[datablockId]="vo.datablockId"
		(emitSubscriptionCount)="getSubscriptionCount($event)"
		(createSubscriptionAction)="createNew()">
	</app-subscription-list>
</ng-container>

